module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-provide-variation', {
    attrs: {
      "variation": _vm.variation,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule
    },
    on: {
      "change": _vm.emitToParent
    }
  }, [_c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Atributos")])]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Gênero",
      "columns": 3,
      "error": _vm.getError('gender', _vm.variation.sku),
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.gender),
      expression: "variation.gender"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.disabledInputs()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.variation, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('netshoes.gender.male.label')) + "\n        ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('netshoes.gender.female.label')) + "\n        ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "unisex"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('netshoes.gender.unisex.label')) + "\n        ")])])]), _vm._v(" "), (Object.keys(_vm.variation.attributes).indexOf('color') !== -1) ? _c('form-group', {
    attrs: {
      "label": _vm.$t("color.label"),
      "columns": 3,
      "error": _vm.getError('color', _vm.variation.sku),
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.attributes['color']),
      expression: "variation.attributes['color']"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "innerHTML": _vm._s(_vm.options('color'))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.variation.attributes, 'color', $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  })]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.variation.attributes).indexOf('flavor') !== -1) ? _c('form-group', {
    attrs: {
      "label": _vm.$t("flavor.label"),
      "columns": 3,
      "error": _vm.getError('flavor', _vm.variation.sku),
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.attributes['flavor']),
      expression: "variation.attributes['flavor']"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "innerHTML": _vm._s(_vm.options('flavor'))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.variation.attributes, 'flavor', $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  })]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.variation.attributes).indexOf('size') !== -1) ? _c('form-group', {
    attrs: {
      "label": _vm.$t("size.label"),
      "columns": 3,
      "error": _vm.getError('size', _vm.variation.sku),
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.attributes['size']),
      expression: "variation.attributes['size']"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "innerHTML": _vm._s(_vm.options('size'))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.variation.attributes, 'size', $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  })]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bd64672","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/netshoes/provide/Variation.vue
// module id = 3066
// module chunks = 0